




























































































import { Component, Emit, InjectReactive, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { FeedReferencePoint, FeedTank } from '@/api';
import { CorrectionService } from '@/services/correction-service';
import Toast from '@/components/display/toast.vue';
import ConfirmModal from '@/components/display/confirm-modal.vue';

@Component({
	components: { ConfirmModal },
})
export default class FeedTankReferencePoints extends Vue {
	@InjectReactive('selectedFeedTank')
	public feedTank!: FeedTank;

	public isDeleting = false;
	public referencePointToDelete: FeedReferencePoint | null = null;

	private toast: Toast = new Toast();

	public fields = [
		{ key: 'event_timestamp', label: 'Date', sortable: true },
		{ key: 'event_type', label: 'Type', sortable: true },
		{ key: 'weight_before', label: 'Before (tonnes)' },
		{ key: 'weight_before_variance', label: 'Variance (tonnes)' },
		{ key: 'weight_change', label: 'Change (tonnes)' },
		{ key: 'sensor_serial_numbers', label: 'In-use sensors' },
		{ key: 'notes', label: 'Notes' },
		{ key: 'created_at', label: 'Created at', sortable: true },
		{ key: 'created_by', label: 'By' },
		{ key: 'deleted_at', label: '', tdClass: 'text-right' },
	];

	public get referencePoints(): FeedReferencePoint[] {
		const list = this.feedTank?.referencepointswithtrashed;
		if (!Array.isArray(list)) return [];
		const createdAt = (rp: FeedReferencePoint) => {
			const v = rp.created_at;
			return v ? new Date(v).getTime() : 0;
		};
		return [...list].sort((a, b) => createdAt(b) - createdAt(a)); // descending (newest first)
	}

	public formatDateOnly(value: string | undefined): string {
		if (!value) return '—';
		const m = moment(value);
		return m.isValid() ? m.format('D-MM-YY') : value;
	}

	public formatDateTime(value: string | undefined): string {
		if (!value) return '—';
		const d = new Date(value);
		return isNaN(d.getTime()) ? value : (this.$options.filters?.shortDateTime?.(value) ?? d.toLocaleString() ?? value);
	}

	public formatCreatedAtDateTime(item: { created_at?: string }): string {
		return this.formatDateTime(item?.created_at);
	}

	public formatEventType(value: string | undefined): string {
		return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() ?? '—';
	}

	public cellEventType(referencePoint: FeedReferencePoint): string {
		return this.formatEventType(referencePoint.event_type);
	}
	public cellBefore(referencePoint: FeedReferencePoint): string {
		if (referencePoint.weight_before === 0) return '—';
		return this.$options.filters?.tonnes?.(referencePoint.weight_before) ?? '—';
	}
	public cellVariance(referencePoint: FeedReferencePoint): string {
		if (referencePoint.weight_before_variance === 0) return '—';
		const formatted = this.$options.filters?.tonnes?.(referencePoint.weight_before_variance) ?? '-';
		return `±${formatted}`;
	}
	public cellChange(referencePoint: FeedReferencePoint): string {
		if (referencePoint.weight_change === 0) return '—';
		return this.$options.filters?.tonnes?.(referencePoint.weight_change) ?? '—';
	}

	public cellNotes(referencePoint: FeedReferencePoint): string {
		return referencePoint.notes ?? '—';
	}
	public getCreatedBy(referencePoint: FeedReferencePoint ): string {
		return referencePoint?.user?.name ?? '—';
	}

	public getCreatedByUserId(referencePoint: FeedReferencePoint): number {
		return referencePoint?.user?.id;
	}

	public rowClass(referencePoint: FeedReferencePoint): string {
		return referencePoint.deleted_at ? 'text-muted table-secondary' : '';
	}

	public confirmDelete(referencePoint: FeedReferencePoint): void {
		this.referencePointToDelete = referencePoint;
		this.$bvModal.show('delete-reference-point-modal');
	}

	public async deleteSelectedReferencePoint(): Promise<void> {
		const feedTankId = this.feedTank?.id;

		if (!this.referencePointToDelete?.id || feedTankId == null) {
			this.$bvModal.hide('delete-reference-point-modal');
			this.referencePointToDelete = null;
			return;
		}

		this.isDeleting = true;
		const { error } = await CorrectionService.deleteFeedTankReferencePoint(feedTankId, this.referencePointToDelete.id);
		this.isDeleting = false;
		this.$bvModal.hide('delete-reference-point-modal');
		this.referencePointToDelete = null;

		if (error) {
			this.toast.makeToast(error, 'Error', 'danger');
			return;
		}

		this.toast.makeToast('Reference point deleted', 'Success', 'success');
		this.onUpdateReferencePoints();
	}

	@Emit('updateReferencePoints')
	public onUpdateReferencePoints(): void {}
}
